import { httpInterceptor } from '../http-interceptor';

// PO service with new unified array-based API endpoints
export class POService {
  static ENDPOINTS = {
    GET_ALL: 'po/getallpos',
    GET_BY_VENDOR_IDS: 'po/getposbyvendorids',
    GET_BY_ID: 'po/getpobyid',
    GET_ITEM_RELEASES: 'po/getitemreleases',
    GET_ITEMS_OF_POS: 'po/getitemsofpos',
    SAVE_RECEIVING_PO: 'po/savereceivingpo',
    GET_ALL_SHIP_TO: 'po/getallshipto',
  };

  // Get all POs (no filtering)
  static async getAllPOs() {
    return httpInterceptor.post(this.ENDPOINTS.GET_ALL);
  }

  // Get POs filtered by vendor IDs and receivingShipmentId
  static async getPOsByVendorIds({ vendorIds, receivingShipmentId }) {
    return httpInterceptor.post(this.ENDPOINTS.GET_BY_VENDOR_IDS, { vendorIds, receivingShipmentId });
  }

  // Get PO by ID
  static async getPOById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${id}`);
  }

  // Get item releases for a specific PO item and shipment
  static async getItemReleases(poItemDetailId, shipmentId = 0) {
    return httpInterceptor.post(this.ENDPOINTS.GET_ITEM_RELEASES, { poItemDetailId, shipmentId });
  }

  // Get PO items for multiple PO IDs
  static async getPOItemsByPOReceivingIds(poReceivingIds, receivingShipmentId = 0) {
    const shipmentId = Number(receivingShipmentId) || 0;
    const url = shipmentId
      ? `${this.ENDPOINTS.GET_ITEMS_OF_POS}?receivingShipmentId=${shipmentId}`
      : this.ENDPOINTS.GET_ITEMS_OF_POS;
    return httpInterceptor.post(url, poReceivingIds);
  }

  static async saveReceivingPO(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_RECEIVING_PO, data);
  }

  static async getAllShipTos() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL_SHIP_TO);
  }
} 